module.exports = __webpack_public_path__ + "img/design.e95a15d8.svg";